export enum ResearchCategory {
  BUSINESS_REGISTRATION = "business_registration",
  CONTRACTOR_LICENSING = "contractor_licensing",
  BUSINESS_PROFILES_AND_REVIEWS = "business_profiles_and_reviews",
  LIENS_AND_CLAIMS = "liens_and_claims",
  CIVIL_COURTS = "civil_courts",
  BANKRUPTCY_COURTS = "bankruptcy_courts",
  GOVERNMENT_ENFORCEMENT = "government_enforcement",
  WORKPLACE_SAFETY = "workplace_safety",
  WEBSITES_AND_DOMAINS = "websites_and_domains",
  NEWS_MEDIA = "news_media",
}

// Every Research Category in its display order.
export const researchCategories = Object.values(ResearchCategory)

export const dataByResearchCategory: Record<
  ResearchCategory,
  { name: string; abbreviatedName: string }
> = {
  [ResearchCategory.BUSINESS_REGISTRATION]: {
    name: "Business Registration",
    abbreviatedName: "Reg",
  },
  [ResearchCategory.CONTRACTOR_LICENSING]: {
    name: "Contractor Licensing",
    abbreviatedName: "Lic",
  },
  [ResearchCategory.BUSINESS_PROFILES_AND_REVIEWS]: {
    name: "Business Profiles and Reviews",
    abbreviatedName: "Prof",
  },
  [ResearchCategory.LIENS_AND_CLAIMS]: {
    name: "Liens and Claims",
    abbreviatedName: "Lien",
  },
  [ResearchCategory.CIVIL_COURTS]: {
    name: "Civil Courts",
    abbreviatedName: "Civ",
  },
  [ResearchCategory.BANKRUPTCY_COURTS]: {
    name: "Bankruptcy Courts",
    abbreviatedName: "Bkr",
  },
  [ResearchCategory.GOVERNMENT_ENFORCEMENT]: {
    name: "Government Enforcement",
    abbreviatedName: "Enf",
  },
  [ResearchCategory.WORKPLACE_SAFETY]: {
    name: "Workplace Safety",
    abbreviatedName: "Safe",
  },
  [ResearchCategory.WEBSITES_AND_DOMAINS]: {
    name: "Websites and Domains",
    abbreviatedName: "Web",
  },
  [ResearchCategory.NEWS_MEDIA]: {
    name: "News Media",
    abbreviatedName: "News",
  },
}
